import React from "react";
import styles from "../styles.module.scss";

// Table header item
interface TableHeaderItemProps {
  title: string | any;
  id?: string;
  styles?: React.CSSProperties;
}

// Table header props
interface TableHeaderProps {
  tableHeaderTitles: TableHeaderItemProps[];
  tableHeadItemClassName?: string;
  tableHeaderClassName?: string;
  tableRowClassName?: string;
  tableHeaderCheck?: {
    value: boolean;
    handleCheck: (val: boolean) => void;
    className?: string;
  };
  tableHeaderCopyCheck?: {
    value: boolean;
    handleCheck: (val: boolean) => void;
    className?: string;
  };
}

/**
 * This is a representation of the table header
 * ---------------------------------------------------
 * @param tableHeaderTitles - @interface TableHeaderProps
 *
 */

const TableHeader: React.FC<TableHeaderProps> = ({
  tableHeaderTitles,
  tableHeadItemClassName = "",
  tableHeaderClassName = "",
  tableHeaderCheck,
  tableHeaderCopyCheck
}) => {
  return (
    <section className={`${styles.tableHeader} ${tableHeaderClassName}`}>
      {tableHeaderCheck && (
        <span className={styles.checkWrap} >
          <input
            className={styles.check}
            onChange={() =>
              tableHeaderCheck.handleCheck(tableHeaderCheck.value)
            }
            checked={tableHeaderCheck.value}
            type={"checkbox"}
          />{" "}
        </span>
      )}
      {tableHeaderTitles.map((header, idx) => {
        const isCV = header.title === "CV";

        return (
          <React.Fragment key={`${header.title}-${idx}`}>
            {/* If it's the CV column, render a separate checkbox cell */}
            {isCV && tableHeaderCopyCheck && (
              <span className={styles.checkWrap}>
                <input
                  className={`${styles.check} ${tableHeaderCopyCheck.className || ""}`}
                  onChange={() =>
                    tableHeaderCopyCheck.handleCheck(!tableHeaderCopyCheck.value)
                  }
                  checked={tableHeaderCopyCheck.value}
                  type="checkbox"
                />
              </span>
            )}

            {/* The actual header title */}
            <span
              style={header.styles}
              className={tableHeadItemClassName}
            >
              {header.title}
            </span>
          </React.Fragment>
        );
      })}

    </section>
  );
};

export { TableHeader };
export type { TableHeaderItemProps, TableHeaderProps };
